import React from "react"
import EditBeneficialOwnerModal, {UpdateBeneficialOwnerFn} from "./EditBeneficialOwnerModal"
import {
	CustomerBeneficialOwner,
	patchCustomerBeneficialOwner,
	PatchCustomerBeneficialOwnerAttributes,
} from "../../resources/customerBeneficialOwner"
import {parsePhoneNumber} from "libphonenumber-js"

interface EditCustomerBeneficialOwnerModalProps {
	customerId: string
	beneficialOwner: CustomerBeneficialOwner
	close: () => void
	refresh: () => void
}

export default function EditCustomerBeneficialOwnerModal({
	customerId,
	beneficialOwner,
	close,
	refresh,
}: EditCustomerBeneficialOwnerModalProps) {
	const updateCustomerBeneficialOwner: UpdateBeneficialOwnerFn = async (accessToken, values) => {
		const updatedPhone = parsePhoneNumber(values.phone)
		const attributes: PatchCustomerBeneficialOwnerAttributes = {
			fullName: {first: values.firstName, last: values.lastName},
			email: values.email,
			address: {
				postalCode: values.postalCode,
				street: values.street,
				street2: values.street2,
				state: values.state,
				city: values.city,
				country: values.country,
			},
			phone: {
				countryCode: updatedPhone.countryCallingCode.toString(),
				number: updatedPhone.nationalNumber.toString(),
			},
			dateOfBirth: values.dateOfBirth,
			ssn: values.identificationType === "ssn" ? values.ssn : undefined,
			passport: values.identificationType === "passport" ? values.passport : undefined,
			nationality: ["passport", "ssn"].includes(values.identificationType)
				? values.nationality === ""
					? null
					: values.nationality
				: null,
			matriculaConsular: values.identificationType === "matriculaConsular" ? values.matriculaConsular : undefined,
			percentage: values.percentage ? +values.percentage : undefined,
		}

		return patchCustomerBeneficialOwner(accessToken, customerId, beneficialOwner.id, attributes)
	}

	return (
		<EditBeneficialOwnerModal
			{...beneficialOwner.attributes}
			close={close}
			refresh={refresh}
			updateBeneficialOwner={updateCustomerBeneficialOwner}
		/>
	)
}
